import React, { useCallback, useEffect, useState } from 'react';
import { Card } from '../../../../../../Opportunity/list/components/OpportunitiesList/components/Kanban/styles';
import { Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import LeadHistoryModal from '../../../LeadHistoryModal';
import ModalConfirmation from 'components/Modal/ConfirmationModal';
import LeadService from '../../../../../services/leadService';
import { toast } from 'react-toastify';
import { verifyRoles } from 'components/Authentication/VerifyRoles';
import LeadActionsModalKanban from '../../../LeadActionsModalKanban';
import ConversationDetails from 'components/Conversation/ConversationDetails';

export const InfoCardLead = ({
  data: info,
  dragStart,
  dragEnter,
  onTableGrow,
  stagePageInfo
}) => {
  const cardProps = info.data.array[info.index];
  const history = useHistory();
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [leadConversations, setLeadConversations] = useState([]);

  useEffect(() => {
    if (info.index === info.data.array.length - 6 && stagePageInfo) {
      const stage = stagePageInfo.find((data_) => {
        return data_.id === cardProps.stageId;
      });

      if (!stage) return;
      if (stage.count > info.data.array.length) {
        onTableGrow(cardProps.stageId);
        return;
      }
    }
  }, []);

  useEffect(() => {
    if (cardProps?.id) {
      LeadService.getConversationsByLead(cardProps.id)
        .then((res) => {
          setLeadConversations(res.data.conversas || res.data.data || []);
        })
        .catch(() => {
          // Não exibe erro se não houver conversas associadas
          setLeadConversations([]);
        });
    }
  }, [cardProps?.id]);

  const removeItem = () => {
    info.data.setValuesList((prev) => {
      const copyList = { ...prev };
      const index = copyList[info.data.list].findIndex((item) => {
        return item.id === cardProps.id;
      });
      copyList[info.data.list].splice(index, 1);
      return copyList;
    });
  };

  const handleDeleteLead = useCallback((id) => {
    LeadService.delete(id)
      .then(() => {
        removeItem();
      })
      .catch((err) => {
        const message =
          err?.response?.data?.message || 'Erro ao deletar o lead';
        toast.error(message);
      })
      .finally(() => {
        setOpenModalConfirmation(false);
      });
  }, []);

  return (
    <>
      <Card
        style={{
          ...info.style,
          color: 'black',
          justifyContent: 'center',
          border:
            cardProps.dated && !cardProps.isConverted ? '2px solid red' : ''
        }}
        onDragStart={(e) => dragStart(e, info.index, info.data.list)}
        onDragEnter={(e) => dragEnter(e, info.index)}
        draggable={true}
        key={cardProps?.id}
        id={'draggable' + cardProps?.id}
      >
        <div className="card-padding-before">
          <div
            title={cardProps.title ?? cardProps.name}
            className="CardContent"
          >
            <p>{cardProps.title ?? cardProps.name}</p>
            <span>{cardProps.responsibleName}</span>
            <div>
              {cardProps.dated && !cardProps.isConverted ? (
                <div
                  style={{
                    fontSize: '12px',
                    fontWeight: 'lighter',
                    color: 'red',
                    marginTop: '28px'
                  }}
                >
                  Vencido há {cardProps.daysDated} dia(s)
                </div>
              ) : (
                ''
              )}
              {!cardProps.isConverted ? (
                <div
                  style={{
                    fontSize: '12px',
                    fontWeight: 'lighter',
                    color: 'black'
                  }}
                >
                  Há {cardProps.daysInStage} dia(s) na fase
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
          <div className="button-container">
            {leadConversations.length > 0 &&
              leadConversations.map((conversation, index) => (
                <ConversationDetails
                  key={conversation._id || conversation.id || index}
                  conversationData={conversation}
                  useIcon={true}
                  buttonSize="sm"
                  buttonColor="success"
                />
              ))}
            {!cardProps?.isConverted ? (
              <>
                <Button
                  title="Editar"
                  onClick={() => {
                    history.push(
                      `/admin/crm/leadEdit/${cardProps.recordTypeId}/${cardProps.id}`
                    );
                  }}
                  size="sm"
                  color="info"
                >
                  <i className="fas fa-user-edit"></i>
                </Button>

                <LeadHistoryModal
                  leadId={cardProps.id}
                  style={{ scale: 0.9 }}
                />

                <ModalConfirmation
                  isModalOpen={openModalConfirmation}
                  onModalToggle={setOpenModalConfirmation}
                  unmountOnClose={true}
                  idResource={cardProps.id}
                  deleteResource={handleDeleteLead}
                  message={'Tem certeza que deseja excluir o lead?'}
                />

                <LeadActionsModalKanban leadData={cardProps} />

                {verifyRoles(['DELETE_LEAD_CRM']) && (
                  <Button
                    size="sm"
                    color="danger"
                    onClick={() => setOpenModalConfirmation(true)}
                    style={{ marginTop: '-25px' }}
                  >
                    <li className="fas fa-trash"></li>
                  </Button>
                )}
              </>
            ) : (
              <>
                <LeadHistoryModal leadId={cardProps.id} />
                <LeadActionsModalKanban leadData={cardProps} />
              </>
            )}
          </div>
        </div>
      </Card>
    </>
  );
};
